import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import { RegularHeader } from './RegularHeader';

type Props = {
  isFullScreen?: boolean,
  isSticky?: boolean,
  handleClose: Function,
  hasCloseButton?: boolean,
  title: string,
  titleAriaHidden?: boolean,
  titleIcon?: Node | string,
  titleId?: string,
  titleCentered?: boolean,
  headerInView: boolean,
  progressValue?: number,
  onBackButtonClick?: Function,
  mode?: string,
};

export const ModalHeader = ({
  isFullScreen,
  isSticky,
  handleClose,
  hasCloseButton,
  title,
  titleAriaHidden,
  titleIcon,
  titleId,
  titleCentered,
  headerInView,
  progressValue,
  onBackButtonClick,
  mode,
}: Props) => {
  const { t } = useTranslation('common');

  return (
    <>
      {isFullScreen && <FullWidthOverlay />}

      <RegularHeader
        title={title}
        titleAriaHidden={titleAriaHidden}
        titleIcon={titleIcon}
        titleId={titleId}
        titleCentered={titleCentered}
        handleClose={handleClose}
        hasCloseButton={hasCloseButton}
        headerInView={headerInView}
        progressValue={progressValue}
        onBackButtonClick={onBackButtonClick}
        isStickyOnFullScreen={isSticky}
        isFullScreen={isFullScreen}
        mode={mode}
        buttonAriaLabel={t('closeDialog')}
      />
    </>
  );
};

const FullWidthOverlay = styled.div`
  position: fixed;
  z-index: -1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: ${({ theme }) => theme.color.white};
  justify-content: flex-start;
`;
